module.exports = __webpack_public_path__ + "img/fail_icon.51e03e37.png";